/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Whether the reading was taken on delivery or at service
 */
export enum HotHoldingAlertDetailResponseDtoReadingType {
  DELIVERY = "DELIVERY",
  SERVICE = "SERVICE",
}
